
export class InputNumberValidator {

    private static readonly allowedCharacters = [
        " ",
        ".",
        ",",
        "-",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9"
    ];

    static scrubDirtyDataTransferText(text: string): string {
        if (text === null || text === undefined) {
            return "";
        }
        // Tar bort all whitespace
        return text.replace(/\s+/g, "");
    }

    /**
     * Validerar input
     *
     * @param allowDecimals Om decimaltal är tillåtna
     * @param allowNegative Om negativa tal är tillåtna
     * @param input Text att validera
     * @param event Event som ignoreras om det inte är giltigt
     * @returns void
     */
    static validateEventInput(allowDecimals: boolean, allowNegative: boolean, min: number, max: number, input: string, value: string, event: Event): void {
        if (input === null || input === undefined || input === "") {
            return;
        }

        if (this.containsInvalidCharacters(input) ||
            this.invalidForNegative(allowNegative, input) ||
            this.invalidForDecimal(allowDecimals, input) ||
            this.invalidOutOfRange(min, max, input, value)) {

            this.ignoreEvent(event);
        }
    }

    /**
     * Kontrollerar att endast tillåtna värden finns med i texten
     *
     * @param text Texten att kontrollera
     * @returns true om felaktiga tecken existerar, false om enbart tillåtna tecken existerar
     */
    private static containsInvalidCharacters(text: string): boolean {
        for (let index = 0; index < text.length; index++) {
            const char = text.charAt(index);
            if (!this.allowedCharacters.includes(char)) {
                return true;
            }
        }
        return false;
    }

    private static invalidForNegative(allowNegative: boolean, text: string): boolean {
        return (allowNegative === false && (text.includes("-")));
    }

    private static invalidForDecimal(allowDecimal: boolean, text: string): boolean {
        return (allowDecimal === false && (text.includes(",") || text.includes(".")));
    }

    private static invalidOutOfRange(min: number, max: number, input: string, value: string) {
        const sum = parseFloat(value + input);

        if (isNaN(sum)) {
            return false;
        }

        return sum < min || sum > max;
    }

    private static ignoreEvent(event: Event) {
        event.stopPropagation();
        event.preventDefault();
    }
}
